import { render } from "./ProductGridSkeleton.vue?vue&type=template&id=5e76fc7b&scoped=true"
import script from "./ProductGridSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductGridSkeleton.vue?vue&type=script&lang=js"

import "./ProductGridSkeleton.vue?vue&type=style&index=0&id=5e76fc7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e76fc7b"]])

export default __exports__